import { MAX_CAROUSEL_CARDS } from './constants';
export function isCategoryPreviewSectionEmpty(props) {
    return !props?.header || !props?.cards || !props?.cards.length;
}
export function formattingFeatureItems(data) {
    return data.slice(0, MAX_CAROUSEL_CARDS);
}
